import React from 'react';
import './Page.less';

export default function Page(props) {
  const { className, header, headerStyle } = props;

  const pageClassName = `page ${className || ''}`;

  return (
    <section style={props?.styleSection} className={pageClassName}>
      <div style={{ padding: '2.5em 3em' }}>
        { header && (
          <h2 style={headerStyle} className="page-header">{header}</h2>
        )}
        {props.children}
      </div>
    </section>
  );
}
